import { DoorSize } from '../../common/door-size';
import { StormDoorHandleType } from '../../common/storm-door-handle-type';
import { IProductTexture, ProductTexture } from '../../common/product-texture';
import { IDoorSizeOption, DoorSizeOption } from '../../common/door-size-option';
import { IStormDoorHandleTypeOption, StormDoorHandleTypeOption } from '../../common/storm-door-handle-type-option';
import { IStormDoorColorOption, StormDoorColorOption } from '../../common/storm-door-color-option';

export interface IStormDoorEditingModel {
    id: string;
    isActive: boolean;
    description: string;
    productUrl: string;
    brand: string;
    familyId: string;
    doorSize: DoorSize;
    validHandlesets: StormDoorHandleType;
    includesHandle: boolean;
    cutdownPossible: boolean;
    imageUrls: string[];
    sellingPoints: string[];
    textureVariants: IProductTexture[];
    price: number;
    inStoreQuantity: number;
    isNotAvailable: boolean;
    pickupLeadTimeDays: number;
    doorSizes: IDoorSizeOption[];
    doorHandleTypes: IStormDoorHandleTypeOption[];
    doorColors: IStormDoorColorOption[];
    productReviewSummary: string;
    additionalInstallLabor?: number;
    laborFeeCoefficient?: number;
}


export class StormDoorEditingModel implements IStormDoorEditingModel {
    public id: string = '';
    public isActive: boolean = false;
    public description: string = '';
    public productUrl: string = '';
    public brand: string = '';
    public familyId: string = '';
    public doorSize: DoorSize = DoorSize.Indeterminate;
    public validHandlesets: StormDoorHandleType = StormDoorHandleType.Indeterminate;
    public includesHandle: boolean = false;
    public cutdownPossible: boolean = false;
    public imageUrls: string[] = [];
    public sellingPoints: string[] = [];
    public textureVariants: IProductTexture[] = [];
    public price: number = 0;
    public inStoreQuantity: number = 0;
    public isNotAvailable: boolean = false;
    public pickupLeadTimeDays: number = 0;
    public doorSizes: IDoorSizeOption[] = [];
    public doorHandleTypes: IStormDoorHandleTypeOption[] = [];
    public doorColors: IStormDoorColorOption[] = [];
    public productReviewSummary: string = '';
    public additionalInstallLabor?: number = undefined;
    public laborFeeCoefficient?: number = undefined;
}


